import { PageComboBoxModel } from '../page-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページリストを取得する
 *
 * @export API通信成功時の処理
 * @class GetPageListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPageListService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: PageComboBoxModel = null;
  private orderCode: string = null;
  private mediumType: string = null;
  private coopCode: string = null;
  private successFunc: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode,
        MediumType: this.mediumType,
        CoopCode: this.coopCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {PageComboBoxModel} model
   * @param {string} orderCode
   * @param {string} mediumType
   * @param {string} coopCode
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetPageListService
   */
  execute(model: PageComboBoxModel, orderCode: string, mediumType: string, coopCode: string, successFunc: Function = null) {
    this.model = model;
    this.orderCode = orderCode;
    this.mediumType = mediumType;
    this.coopCode = coopCode;
    this.successFunc = successFunc;
    this.send('KYMW02getPageList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPageListService
   */
  success(data: any) {
    this.model.updatePageList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
